import React, {Component} from 'react';
import LoadingButton from '../../../../shared/ui/LoadingButton';
import defaultPropertiesUpdateFn from '../../../models/form/defaultPropertiesUpdateFn';
import textValidationFn from '../../../models/form/validation/text';
import ValidatingTextInput from '../../../../shared/components/form/ValidatingTextInput';
import ValidatingTextarea from "../../../../shared/components/form/ValidatingTextarea";

class TaskForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isTouched: false,
      properties: {
        prompt: {
          isValid: !!props.initialValues,
          name: 'prompt',
          value: props.initialValues ? props.initialValues.prompt : '',
        },
        min_responses: {
          isValid: true,
          name: 'min_responses',
          value: props.initialValues ? props.initialValues.min_responses : '',
        }
      },
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  // ----------------------
  // Computed
  // ----------------------

  get isFormValid() {
    return (
      !Object.keys(this.state.properties).find((key) => {
        return !this.state.properties[key].isValid;
      })
    );
  }

  // ----------------------
  // Methods
  // ----------------------

  handleChange(valueObject) {
    const callback = () => {
      if (!this.state.isTouched) {
        this.setState({isTouched: true});
      }
    };
    this.setState(
      defaultPropertiesUpdateFn(valueObject.name, valueObject),
      callback,
    );
  }

  handleSubmit(event) {
    event.preventDefault();
    const properties = {
      prompt: this.state.properties.prompt.value.trim(),
      min_responses: this.state.properties.min_responses.value
    };
    this.props.onSave(properties);
  }

  // ----------------------
  // Render
  // ----------------------

  render() {
    return (
      <div className="app-content">
        <form noValidate onSubmit={this.handleSubmit}>
          <ValidatingTextarea
            initialValue={
              this.props.initialValues ? this.props.initialValues.prompt : ''
            }
            label="Prompt"
            onChange={this.handleChange}
            name="prompt"
            required
            validationFn={textValidationFn('Prompt', true)}
            value={this.state.properties.prompt.value}
          />
          <ValidatingTextInput
            label="Min responses"
            className="form-control"
            name="min_responses"
            initialValue={
              this.props.initialValues ? this.props.initialValues.min_responses : ''
            }
            onChange={this.handleChange}
            validationFn={() => null}
            value={this.state.properties.min_responses.value}
          />

          <div className="text-right">
            <LoadingButton
              disabled={!this.isFormValid}
              isLoading={this.props.isLoading}
              primary
              text="Submit"
            />
          </div>
        </form>
      </div>
    );
  }
}

export default TaskForm;
